// Mini-CRM pipeline stages — single source of truth.
//
// Locked at 7 values (6 active + Declined) to match the leads_status_minicrm_check
// DB constraint. Changing this list requires a paired migration to update the
// constraint.
//
// Order matters for the kanban column layout (left → right).
// Declined is intentionally NOT in PIPELINE_STAGES — it lives in the archive
// area, surfaced via a separate filter chip rather than as a column.
//
// 2026-05-11: added "Invoiced" between Booked and Done. Auto-transitioned when
// the tradie sends an invoice. Done now means "Paid" — moved manually for now
// via the "Mark as paid" button on Invoiced cards (Stripe automation pending).

export const PIPELINE_STAGES = [
  {
    id: "New",
    label: "New",
    description: "Fresh lead, not yet quoted",
    color: "#3B82F6", // blue
    bg: "rgba(59, 130, 246, 0.10)",
  },
  {
    id: "Quoted",
    label: "Quoted",
    description: "Quote sent, awaiting customer",
    color: "#8B5CF6", // violet
    bg: "rgba(139, 92, 246, 0.10)",
  },
  {
    id: "Accepted",
    label: "Accepted",
    description: "Customer accepted, not yet scheduled",
    color: "#22C55E", // green
    bg: "rgba(34, 197, 94, 0.10)",
  },
  {
    id: "Booked",
    label: "Booked",
    description: "Scheduled job — your TODO",
    color: "#FF8A00", // brand orange (your active queue)
    bg: "rgba(255, 138, 0, 0.10)",
  },
  {
    id: "Invoiced",
    label: "Invoiced",
    description: "Invoice sent, awaiting payment",
    color: "#EAB308", // amber — money owed, not yet collected
    bg: "rgba(234, 179, 8, 0.10)",
  },
  {
    id: "Done",
    label: "Done (paid)",
    description: "Complete + invoiced + paid",
    color: "#0F766E", // teal — success, deeper than green Accepted
    bg: "rgba(15, 118, 110, 0.10)",
  },
];

// Stages NOT shown in the main board — they live in the archive area.
export const ARCHIVE_STAGES = [
  {
    id: "Declined",
    label: "Declined",
    description: "Customer declined the quote",
    color: "#9CA3AF", // grey
    bg: "rgba(156, 163, 175, 0.10)",
  },
];

// Convenience lookups.
export const STAGE_IDS = PIPELINE_STAGES.map((s) => s.id);
export const ALL_STATUS_VALUES = [
  ...PIPELINE_STAGES.map((s) => s.id),
  ...ARCHIVE_STAGES.map((s) => s.id),
];

const STAGE_BY_ID = new Map(
  [...PIPELINE_STAGES, ...ARCHIVE_STAGES].map((s) => [s.id, s])
);

export function getStage(id) {
  return STAGE_BY_ID.get(id) || null;
}
